export const InfoSection = ({ icon, label, text, additional }) => {
    return (
        <section className='mt-2'>
            <p className='flex items-baseline font-antonio text-dark-blue'>{icon}<b>{label}</b></p>
            <p className='flex items-baseline font-antonio opacity-[60%] ml-6 text-[15px] lg:text-[18px] text-left'>{text}</p>
            {additional && <p className='flex items-baseline font-antonio opacity-[60%] ml-6 text-[15px] lg:text-[18px]'>{additional}</p>}
        </section>
    )
}